import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import RefreshIcon from '@mui/icons-material/Refresh';

const ServerError = () => {
  const theme = useTheme();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme => theme.palette.mode === 'dark' 
          ? 'rgba(0, 0, 0, 0.9)' 
          : 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(10px)',
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          p: 4,
          borderRadius: 4,
          backgroundColor: theme => theme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.05)' 
            : 'rgba(255, 255, 255, 0.8)',
          border: theme => `1px solid ${
            theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.1)'
              : 'rgba(0, 0, 0, 0.1)'
          }`,
          maxWidth: 400,
          mx: 2,
        }}
      >
        <Box sx={{
          '@keyframes spin': {
            from: {
              transform: 'rotate(0deg)'
            },
            to: {
              transform: 'rotate(360deg)'
            }
          },
        }}>
          <BuildIcon 
            sx={{ 
              fontSize: 100, 
              color: theme => theme.palette.mode === 'dark' 
                ? 'rgba(255, 255, 255, 0.7)' 
                : 'rgba(0, 0, 0, 0.7)',
              mb: 2,
              animation: 'spin 3s linear infinite'
            }} 
          />
        </Box>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
          Under Maintenance
        </Typography>
        <Typography variant="h6" gutterBottom color="text.secondary">
          We're Making Things Better
        </Typography>
        <Typography color="text.secondary" paragraph sx={{ mb: 4 }}>
          Our team is currently performing scheduled maintenance to improve your experience. We'll be back online shortly. Thank you for your patience!
        </Typography>
        <Button
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={handleRefresh}
          sx={{
            px: 4,
            py: 1,
            borderRadius: 2,
            textTransform: 'none',
            backgroundColor: theme => theme.palette.mode === 'dark' 
              ? 'rgba(37, 99, 235, 0.8)' 
              : '#2563EB',
            '&:hover': {
              backgroundColor: theme => theme.palette.mode === 'dark' 
                ? 'rgba(37, 99, 235, 0.9)' 
                : '#1D4ED8',
            },
          }}
        >
          Refresh Page
        </Button>
      </Box>
    </Box>
  );
};

export default ServerError;
